import { createReducer, on } from '@ngrx/store';
import * as authActions from './auth.action';
import { authState } from './auth.state';

const authReducer = createReducer(
  authState,
  on(authActions.loginSuccess, (state, action) => ({
    ...state,
    user: action.payload,
    isAuthenticated: true,
  })),
  on(authActions.loginCancel, (state) => ({
    ...state,
    isAuthenticated: false,
  })),
  on(authActions.logoutSuccess, (state) => ({
    ...state,
    isAuthenticated: false,
  })),
  on(authActions.getCompanyDetailsSuccess, (state, payload) => ({
    ...state,
    companyDetails: payload.payload,
  })),
  on(authActions.getCompanyKioskSettingsSuccess, (state, payload) => ({
    ...state,
    kioskSettings: payload.payload,
  }))
);

export default authReducer;
